import { useTranslations } from "next-intl";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import Button from "@components/core/Button";
import ClosetItemValidationCard from "./ClosetItemValidationCard";

function ClosetItemsValidation({ setStep }) {
  const t = useTranslations("common");

  const currentCloset = useCustomizableCloset();

  function goBack() {
    setStep("closetChange");
  }

  return (
    <div className="p-3 bg-white rounded-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <p className="font-weight-bold font-size-sm text-uppercase mb-0">
          {t("drawer.modal_rtc.validate.inside_closet")}
        </p>

        <div>
          <Button
            variant="link-primary"
            className="no-underline"
            onClick={goBack}
            hugContent
          >
            {t("drawer.modal_rtc.validate.change")}
          </Button>
        </div>
      </div>

      <div className="d-flex flex-column gap-1">
        {currentCloset.closet_items?.map((closetItem) => (
          <ClosetItemValidationCard
            key={closetItem.id}
            closetItem={closetItem}
          />
        ))}
      </div>
    </div>
  );
}

export default ClosetItemsValidation;
